module.exports = __webpack_public_path__ + "static/media/vote-btn.b2cb75c6.png";